import { render, staticRenderFns } from "./LibraryTabs.vue?vue&type=template&id=79a5fd11&scoped=true"
import script from "./LibraryTabs.vue?vue&type=script&lang=js"
export * from "./LibraryTabs.vue?vue&type=script&lang=js"
import style0 from "./LibraryTabs.vue?vue&type=style&index=0&id=79a5fd11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5fd11",
  null
  
)

export default component.exports